import React from 'react'
import styles from './Viewer.module.scss'
const PreviewViewer = ({viewerName, type}:{viewerName:string, type:string}) => {
    
    const servicePreviewInfo = {
        "객실 제어" : "home_service_preview_roomcontrol.svg",
        "어메니티" : "home_service_preview_amenity.svg",
        "룸서비스" : "home_service_preview_roomservice.svg",
        "FAQ" : "home_service_preview_faq.svg",
        "프론트 문의" : "home_service_preview_front.svg",
        "출차 요청" : "home_service_preview_valet.svg",
        "1:1 채팅문의" : "home_service_preview_chat.svg",
    }

    const managePreviewInfo = {
        "객실 관리" : "home_manage_preview_roomcotrol.svg",
        "어메니티 관리" : "home_manage_preview_amenity.svg",
        "룸서비스 관리" : "home_manage_preview_roomservice.svg",
        "컨시어지" : "home_manage_preview_con.svg",
        "출차 관리" : "home_manage_preview_valet.svg",
        "1:1 채팅문의" : "home_manage_preview_chat.svg",
    }
    
    const servicePreviewInfoMap = new Map(Object.entries(servicePreviewInfo));
    const managePreviewInfoMap = new Map(Object.entries(managePreviewInfo));

    const viewName = type === "service" ? servicePreviewInfoMap.get(viewerName) : managePreviewInfoMap.get(viewerName) ;
    const imgURL = process.env.PUBLIC_URL + '/images/' + viewName;
    
    return (
        <div className={`${styles.viewer} mgt16`}>
            {/* 리렌더링시 애니메이션 실행을 위해 key 값을 줌 */}
            <img key={viewName} src={imgURL} alt={viewName}/>
        </div>
    )
}

export default PreviewViewer
